import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

i18n
    .use(initReactI18next) // předá i18n instance do react-i18next
    .init({
        resources: {
            cs: {
                translation: {
                    login: "Přihlásit se",
                    loginToErp: 'Přihlášení do ERP systému',
                    typeYourPassword: "Zadejte heslo",
                    typeYourEmail: "Zadejte email",
                    didUForgotPassword: "Zapomněli jste heslo?",
                    passwordRecovery: "Obnova zapomenutého hesla",
                    passwordConfirmation: "Zadejte heslo znovu",
                    send: 'Odeslat',
                    backToLogin: 'Zpět na přihlášení',
                    remember: 'Zapamatovat',
                    purchase: 'Správa výkupu',
                    repairManagement: 'Správa oprav',
                    warehouseManagement: 'Správa skladu',
                    deviceManagement: 'Správa zařízení',
                    dashboard: 'Dashboard',
                    categories: 'Kategorie',
                    description: 'Popis',
                    createdBy: 'Vytvořil',
                    name: 'Jméno',
                    surname: 'Příjmení',
                    phone: 'Mobil',
                    email: 'E-mail',
                    city: 'Město',
                    zip: 'PSČ',
                    houseNumber: 'Číslo popisné',
                    street: 'Ulice',
                    country: 'Země',
                    customerName: 'Zákazník',
                    title: 'Název',
                    createdAt: 'Vytvořeno',
                    warehouse: {
                        items: 'Položky skladu'
                    },
                    addCategory: 'Přidat kategorii',
                    confirmCategoryDeletion: 'Opravdu chcete smazat kategorii "{{category}}"?',
                    invalidCredentials: 'Špatné přihlašovací údaje',
                    addPart: 'Přidat díl',
                    confirmDeletion: 'Potvrdit smazání',
                    category: 'Kategorie',
                    save: 'Uložit',
                    discount: 'Sleva',
                    addDevice: 'Přidat zařízení',
                    RepairEditor: {
                        addRepair: 'Přidat zařízení',
                    },
                    updateDevice: 'Upravit zařízení',
                    addNewDevice: 'Přidat nové zařízení',
                    cancel: 'Zrušit',
                    confirm: 'Potvrdit',
                    update: 'Upravit',
                    active: 'Aktivní',
                    repairName: 'Oprava',
                    price: 'Cena',
                    repairList: 'Seznam oprav',
                    timeRequirement: 'Náročnost',
                    deleteImage: 'Smazat obrázek',
                    setNewPassword: 'Nastavte si nové heslo',
                    password: 'Heslo',
                    setNewPasswordAgain: 'Heslo znovu',
                    compatibleWith: 'Kompatibilní s',
                    addNewPart: 'Přidat díl',
                    editPart: 'Upravit díl',
                    complatibleWith: 'Kompatibilní s',
                    new: 'Nový',
                    used: 'Použitý',
                    aftermarket: 'Aftermarket',
                    oeiginal: 'Originál',
                    quality: 'Kvalita',
                    stockQuantity: 'Skladové množství',
                    categoryCode: 'Kód kategorie',
                    condition: 'Stav',
                    searchByName: 'Zadejte název produktu, nebo název, či kód kategorie',
                    filterByCategory: 'Filtrovat dle kategorie',
                    storagePlace: 'Místo uskladnění',
                    reorderThreshold: 'Limit pro naskladnění',
                    RepairEditorRepair: {
                        selectDevice: 'Vyberte zařízení',
                        noAvailableRepairs: 'Pro vybrané zařízení nejsou k dispozici žádné opravy',
                        selectRepair: 'Vyberte opravu',
                    },
                    status: 'Stav',
                    pendingStatus: 'Čekající',
                    in_processStatus: 'Započata',
                    customerRefusedStatus: 'Zrušeno zákazníkem',
                    technicianRefusedStatus: 'Zrušeno technikem',
                    estimatedPrice: 'Očekávaná cena',
                    note: 'Poznámka',
                    notes: 'Poznámky',
                    addNote: 'Přidat poznámku',
                    repairs: {
                        addCustomer: 'Přidat zákazníka',
                        customer: 'Zákazník',
                        repairsCount: 'Zařízení (opravy)',
                        orderPrice: 'Předběžná cena: {{price}}',
                        dueDateLabel: 'Datum dokončení',
                        repairList: 'Seznam oprav',
                        addRepair: 'Přidat opravu',
                        selectDevice: 'Vyberte zařízení',
                        label: 'Opravy',
                        addNewRepair: 'Nová oprava',
                        editRepair: 'Úprava opravy',
                        customerAddress: 'Adresa zákazníka',
                        customerBasicInfo: 'Základní informace o zákazníkovi',
                        orderInfo: 'Informace k opravě',
                        dueDate: 'Požadovaný termín dokončení opravy',
                        estimatedPrice: 'Předpokládaná cena opravy',
                        datesAndTotals: 'Souhrn',
                        noParts: 'Žádné díly doposud nebyly využity',
                        detail: 'Detail opravy',
                        repairItems: 'Položky opravy',
                        partsUsed: 'Využité díly',
                        cancelRepair: 'Zrušit opravu',
                        addPart: 'Přidat díl',
                        finishedAt: 'Dokončeno',
                        startWork: 'Začít pracovat',
                        stopWork: 'Ukončit práci',
                        logWork: 'Vykázat čas',
                        manualWorkLog: 'Ruční výkaz času',
                        workedMinutes: 'Odpracováno',
                        workSessions: 'Záznamy práce',
                        noWorkSessions: 'Zatím bez časových záznamů',
                        from: 'Od',
                        to: 'Do',
                        durationMinutes: 'Minuty',
                        setStatus: 'Nastavit stav',
                        resolution: 'Vyřešení',
                        statusHistory: 'Historie stavů',
                        noStatusHistory: 'Bez historie změn stavu'
                    },
                    repairStatus: {
                        pending: 'Čekající',
                        in_progress: 'Na sále',
                        completed: 'Dokončená',
                        cancelled: 'Zrušená',
                        customerRefused: 'Odmítnuto zákazníkem',
                        technicianRefused: 'Odmítnuto technikem',
                        paused: 'Pozastaveno',
                        waiting_parts: 'Čeká se na díly',
                        waiting_customer: 'Čeká se na zákazníka',
                        waiting_external: 'Čeká se na externí servis',
                        blocked: 'Blokováno',
                        not_repairable: 'Nelze opravit'
                    },
                    DeviceModal: {
                        availableRepairs: 'Vyberte opravy'
                    },
                    date: 'Datum',
                    categoryList: 'Seznam kategorií',
                    limit: 'Limit',
                    back: 'Zpět',
                    addRepair: 'Přidat opravu',
                    amount: 'Hodnota',
                    part: 'Náhradní díl',
                    compatibility: 'Kompatibilita',
                    partLog: 'Logy dílů',
                    label: 'Popis',
                    expectedPurchasePricePerUnit: 'Odhadovaná cena za kus',
                    vatRate: 'DPH %',
                    gross: 'S DPH',
                    net: 'Bez DPH',
                    currency: 'Měna',
                    purchasePrice: 'Ø Cena/jednotka',
                    confirmDeviceDeletion: 'Opravdu chcete smazat zařízení "{{device}}"?',
                    confirmRepairDeletion: 'Opravdu chcete smazat opravu "{{device}}"?',
                    partOrderManagement: 'Objednávky dílů',
                    partOrders: {
                        addOrder: 'Nová objednávka',
                        detail: 'Detail objednávky',
                        inProgress: 'Čekajicí',
                        finished: 'Dokončená',
                        finishedAt: 'Kompletně přijata',
                        itemDelivered: 'Položka doručena',
                        markDelivered: 'Naskladnit',
                        itemPending: 'Nedoručeno'
                    },
                    orderId: "ID objednávky",
                    orderDate: 'Datum objednávky',
                    finishedDate: 'Ukončení objednávky',
                    items: 'Položky',
                    quantity: 'Kvantita',
                    orderDetailUrl: 'URL objednávky',
                    noItems: 'Žádné položky',
                    discountType: 'Typ',
                    discountValue: 'Hodnota',
                    search: 'Vyhledat',
                    searchByLabelOrId: 'Hledal dle ID, nebo popisu',
                    addItem: 'Přidat položku',
                    percentage: 'Procentuální',
                    fixed: 'Fixní',
                    total: 'Celkem',
                    trackingUrl: 'Sledovací URL',
                    pricePerUnit: 'Cena za jednotku',
                    totalQuantity: 'Počet kusů celkem',
                    deviceCode: 'Kód zařízení',
                    stockPriority: 'Skladová priorita',
                    stockQuantityInfo: 'Předchozí / nová dostupnost',
                    confirmOrderDeletion: 'Opravdu chcete smazat objednávku "{{order}}"?',
                    users: {
                        label: 'Uživatelé',
                        addUser: 'Přidat uživatele',
                        editUser: 'Upravit uživatele',
                        profiles: 'Profily',
                        lastSignIn: 'Poslední přihlášení',
                        sendResetLink: 'Odeslat pozvánku s nastavením hesla'
                    },
                    buyback: {
                        label: 'Výkup zařízení',
                        addBuyback: 'Nový výkup',
                        buybackNumber: 'Číslo výkupu',

                        basicAndWorkflow: 'Základ & workflow',
                        source: 'Zdroj',
                        sourceNote: 'Poznámka ke zdroji',
                        acquisitionType: 'Typ akvizice',
                        fromCustomer: 'Výkup od zákazníka',
                        selfPurchase: 'Vlastní nákup',
                        sourceCustomer: 'Zákazník',
                        sourceMarketplace: 'Marketplace',

                        marketplace: 'Platforma',
                        sellerName: 'Jméno inzerenta / prodejce',
                        listingId: 'ID inzerátu',
                        customer: 'Zákazník',
                        customerPlaceholder: 'Vyber nebo napiš zákazníka',
                        price: 'Cena',

                        valuation: 'Ocenění',
                        basePrice: 'Základní cena',
                        additions: 'Přičtení',
                        deductions: 'Srážky',
                        offered: 'Nabídnutá',
                        final: 'Finální',
                        offeredPrice: 'Nabídnutá cena',
                        finalPrice: 'Finální cena',
                        netBeforeRepairs: 'Čistá před opravami',
                        netAfterRepairs: 'Čistá po opravách',
                        estimatedRepairCost: 'Odhad nákladů na opravy',
                        targetResalePrice: 'Cílová prodejní cena',
                        currency: 'Měna',
                        vatRatePct: 'DPH (%)',
                        formulaVersion: 'Verze vzorce',

                        payout: {
                            method: 'Způsob výplaty',
                            cash: 'Hotově',
                            bank: 'Bankovní převod',
                            voucher: 'Poukaz',
                            iban: 'IBAN',
                            paidAt: 'Vyplaceno dne',
                            receiptNumber: 'Číslo výplatního dokladu'
                        },

                        legal: 'Právo & soulad',
                        ownershipDeclaration: 'Čestné prohlášení o vlastnictví',
                        gdprConsent: 'Souhlas se zpracováním osobních údajů',
                        purchaseDoc: {
                            number: 'Číslo dokladu',
                            date: 'Datum dokladu',
                            fileUrl: 'Soubor (URL)'
                        },
                        sellerIdDoc: {
                            type: 'Typ dokladu (OP/Pas)',
                            number: 'Číslo dokladu',
                            fileUrl: 'Soubor (URL)',
                            verifiedAt: 'Ověřeno dne'
                        },

                        // seznam / potvrzení mazání (když ho použiješ i v listu)
                        confirmDelete: 'Opravdu chceš smazat výkup {{number}}?'
                    },
                    buybackStatus: {
                        intake: 'Příjem',
                        awaiting_approval: 'Čeká na schválení',
                        offer_sent: 'Nabídka odeslána',
                        customer_deciding: 'Zákazník se rozhoduje',
                        accepted: 'Přijato',
                        rejected: 'Odmítnuto',
                        paid: 'Vyplaceno',
                        stocked: 'Naskladněno',
                        listed_for_sale: 'Zalistováno',
                        sold: 'Prodáno',
                        returned_to_seller: 'Vráceno prodejci',
                        scrapped: 'Likvidace'
                    },

                    // Platformy marketplace
                    platform: {
                        bazos: 'Bazoš',
                        aukro: 'Aukro',
                        facebook_marketplace: 'Facebook Marketplace',
                        sbazar: 'Sbazar',
                        other: 'Jiná'
                    },
                    device: 'Zařízení',
                    customers: {
                        label: 'Zákazníci',
                        addCustomer: 'Přidat zákazníka',
                        customer: 'Zákazník',
                        blacklisted: 'Ban',
                        type: 'Typ',
                        name: 'Jméno',
                        surname: 'Příjmení',
                        company: 'Firma',
                        addresses: 'Adresy',
                        risk: 'Riziko',
                        typePerson: 'Fyzická osoba',
                        typeCompany: 'Firma',
                        companyName: 'Název společnosti',
                        emails: 'E-mailové kontakty',
                        phones: 'Telefonní kontakty',
                        blacklistReason: 'Důvod banu',
                        ico: 'IČO',
                        dic: 'DIČ',
                        vatPayer: 'Plátce DPH'
                    },
                }
            }
        }, lng: "cs", fallbackLng: "cs", interpolation: {
            escapeValue: false
        }
    });

export default i18n;
